import { Button, Form, Input } from 'antd';
import React, { useEffect } from 'react';
import { useCats } from './CatState';
import { useForm } from 'antd/es/form/Form';

function Edit(props) {
    let { updateCat, ed } = useCats()
    let [form] = useForm()

    useEffect(() => {
        form.setFieldsValue(ed)
    }, [ed])

    return (
        <Form
            name="basic"
            form={form}
            labelCol={{
                span: 24,
            }}
            wrapperCol={{
                span: 24,
            }}
            onFinish={updateCat}
            autoComplete="off"
        >
            <Form.Item
                name="id"
                hidden={true}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="Kategoriya nomi"
                name="name"
                rules={[
                    {
                        required: true,
                        message: "Iltimos to'ldiring!",
                    },
                ]}
            >
                <Input />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit">
                    Saqlash
                </Button>
            </Form.Item>

        </Form>
    );
}

export default Edit;